/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import {
  Flex,
  Heading,
  Button,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import { DateTimePicker, TimePicker } from "@progress/kendo-react-dateinputs";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import moment from "moment";
import { MdDeleteSweep } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import FormInput from "../../../components/forms/form-Input";
import { OFFICES_DEFAULT } from "../constants";
import NumericInput from "../../../components/forms/react-hook-numeric-input";
import FormHookDatePicker from "../../../components/forms/form-hook-date-picker";
import ReactHookFormDropdown from "../../../components/forms/react-hook-dropdown";
import {
  useLookupCities,
  useLookupCountries,
  useLookupEmirates,
  useLookupRegions,
} from "../../../services/lookups-mutations";
import { dateTimeFormat } from "../../../utils/constants";

export default function Offices({ onNextStep, onPrevStep, offices, addData }) {
  const [currentEditing, setCurrentEditing] = useState(null);
  const [currentEditingWindow, setCurrentEditingWindow] = useState(null);
  const {
    mutate: getCountries,
    data: countriesListRes,
    // isPending: gettingCountriesList,
    // error: countriesListError,
  } = useLookupCountries();
  const {
    mutate: getRegions,
    data: regionsListRes,
    // isPending: gettingRegionsList,
    // error: regionsListError,
  } = useLookupRegions();
  const {
    mutate: getEmirates,
    data: emiratesListRes,
    // isPending: gettingEmiratesList,
    // error: emiratesListError,
  } = useLookupEmirates();
  const {
    mutate: getCities,
    data: citiesListRes,
    // isPending: gettingCitiesList,
    // error: citiesListError,
  } = useLookupCities();
  useEffect(() => {
    getCountries();
  }, []);
  const {
    handleSubmit,
    control,
    reset,
    resetField,
    getValues,
    setValue,
    setError,
    watch,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: { ...OFFICES_DEFAULT, offices: [...offices] },
  });
  useEffect(() => {
    if (getValues("country")) {
      const countryCode = getValues("country").code;
      getRegions(countryCode);
      getCities(countryCode);
      getEmirates(countryCode);
    }
  }, [watch("country")]);

  const generalFieldProps = { control, errors };
  const formValidationRules = {
    officeId: { required: "Please add office ID" },
    officeName: { required: "Please add office name" },
    officeType: { required: "Please select office type" },
    barcode: { required: "Please add barcode" },
    status: { required: "Please select status" },
  };
  const {
    fields: officeFields,
    // append: officeAppend,
    remove: officeRemove,
    update: officeUpdate,
  } = useFieldArray({
    control: generalFieldProps.control,
    name: "offices",
  });
  const {
    fields: operationalWindowFields,
    append: appendOperationalWindow,
    remove: operationalWindowRemove,
    update: operationalWindowUpdate,
  } = useFieldArray({
    control: generalFieldProps.control,
    name: "operationalWindows",
  });
  useEffect(() => {
    if (addData) addData([...officeFields]);
  }, [watch("offices")]);
  const submitInfo = (data) => {
    const _offices = [...officeFields];
    const office = {
      officeId: data.officeId,
      officeName: data.officeName,
      officeType: data.officeType,
      country: data.country,
      state: data.state,
      emirate: data.emirate,
      city: data.city,
      postalCode: data.postalCode,
      address: data.address,
      barcode: data.barcode,
      startDate: data.startDate,
      inactiveDate: data.inactiveDate,
      status: data.status,
      longitude: data.longitude,
      latitude: data.latitude,
      operationalWindows: operationalWindowFields,
      expanded: false,
    };
    if (currentEditing !== null) {
      _offices[currentEditing] = office;
      setCurrentEditing(null);
    } else {
      _offices.push(office);
    }
    reset({ ...OFFICES_DEFAULT, offices: [..._offices] });
  };
  const addOperationalWindow = () => {
    clearErrors(["startDateTime", "endDateTime", "cutOffTime"]);
    let isDataValid = true;
    const data = getValues();
    if (!data.startDateTime) {
      setError("startDateTime", {
        type: "required",
        message: "Please add start date",
      });
      isDataValid = false;
    }
    if (!data.endDateTime) {
      setError("endDateTime", {
        type: "required",
        message: "Please add end date",
      });
      isDataValid = false;
    }
    if (!data.cutOffTime) {
      setError("cutOffTime", {
        type: "required",
        message: "Please add cut off time",
      });
      isDataValid = false;
    }
    if (!isDataValid) return;
    const window = {
      startDateTime: data.startDateTime,
      endDateTime: data.endDateTime,
      cutOffTime: data.cutOffTime,
    };
    if (currentEditingWindow !== null) {
      operationalWindowUpdate(currentEditingWindow, window);
      setCurrentEditingWindow(null);
    } else {
      appendOperationalWindow(window);
    }

    resetField("startDateTime");
    resetField("endDateTime");
    resetField("cutOffTime");
  };

  const cancelWindowEditing = () => {
    resetField("startDateTime");
    resetField("endDateTime");
    resetField("cutOffTime");
    setCurrentEditingWindow(null);
  };

  const onCountryChange = () => {
    resetField("state");
    resetField("city");
    resetField("emirate");
  };

  const cancelOfficeEditing = () => {
    setCurrentEditing(null);
    reset({ ...OFFICES_DEFAULT, offices: [...officeFields] });
  };

  const editWindowCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit Operational Window"
          cursor="pointer"
          onClick={() => {
            reset({ ...getValues(), ...dataItem, offices: [...officeFields] });

            setCurrentEditingWindow(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteWindowCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete Operational Window"
          cursor="pointer"
          onClick={() => {
            operationalWindowRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };
  const editOfficeCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit Office"
          cursor="pointer"
          onClick={() => {
            reset({ ...getValues(), ...dataItem, offices: [...officeFields] });
            setCurrentEditing(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteOfficeCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete Office"
          cursor="pointer"
          onClick={() => {
            officeRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };
  const expandChange = ({ dataIndex }) => {
    const _offices = [...officeFields];
    _offices[dataIndex].expanded = !_offices[dataIndex].expanded;
    officeUpdate(dataIndex, _offices[dataIndex]);
  };
  function DetailComponent({ dataItem }) {
    return (
      <>
        <Heading
          style={{
            width: "100%",
            fontSize: "14px",
            padding: "10px 0px",
            margin: 0,
          }}
        >
          Operational Windows
        </Heading>
        <Grid data={dataItem.operationalWindows}>
          <GridColumn
            title="Start Date Time"
            cell={(payload) => (
              <td>
                {payload.dataItem.startDateTime ? (
                  moment(payload.dataItem.startDateTime).format(dateTimeFormat)
                ) : (
                  <></>
                )}
              </td>
            )}
          />
          <GridColumn
            title="End Date Time"
            cell={(payload) => (
              <td>
                {payload.dataItem.endDateTime ? (
                  moment(payload.dataItem.endDateTime).format(dateTimeFormat)
                ) : (
                  <></>
                )}
              </td>
            )}
          />
          <GridColumn
            title="Cut Off Time"
            cell={(payload) => (
              <td>
                {payload.dataItem.cutOffTime ? (
                  moment(payload.dataItem.cutOffTime).format(dateTimeFormat)
                ) : (
                  <></>
                )}
              </td>
            )}
          />
        </Grid>
      </>
    );
  }
  return (
    <form onSubmit={handleSubmit(submitInfo)}>
      <Flex w="100%" justify="space-between" flexDirection="row">
        <Heading style={{ width: "100%" }}>Office</Heading>
        <Flex w="100%" justify="flex-end" flexDirection="row">
          <Flex w="100%" justify="flex-end" flexDirection="row" gap="16px">
            <Button type="button" onClick={() => onPrevStep([...officeFields])}>
              Back
            </Button>
            <Button type="button" onClick={() => onNextStep([...officeFields])}>
              Next
            </Button>
          </Flex>
        </Flex>
      </Flex>
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Office Name"
        name="officeName"
        rules={formValidationRules.officeName}
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Office Id"
        name="officeId"
        rules={formValidationRules.officeId}
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Office Type"
        name="officeType"
        rules={formValidationRules.officeType}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        label="Country"
        name="country"
        id="code"
        text="name"
        data={countriesListRes?.data || []}
        placeholder="Select Country"
        dropdownProps={{ filterable: true }}
        onChange={onCountryChange}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        disabled={!watch("country")}
        label="State"
        name="state"
        id="id"
        text="text"
        data={
          regionsListRes?.data.map((elm) => ({
            id: elm.name,
            text: elm.name,
          })) || []
        }
        placeholder="Select State"
        dropdownProps={{ filterable: true }}
        info={!watch("country") ? "Select country To Enable" : ""}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        disabled={!watch("country")}
        label="City"
        name="city"
        id="id"
        text="text"
        data={
          citiesListRes?.data.map((elm) => ({
            id: elm.name,
            text: elm.name,
          })) || []
        }
        placeholder="Select City"
        dropdownProps={{ filterable: true }}
        info={!watch("country") ? "Select country To Enable" : ""}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        disabled={!watch("country")}
        label="Emirate"
        name="emirate"
        id="id"
        text="text"
        data={
          emiratesListRes?.data.map((elm) => ({
            id: elm.name,
            text: elm.name,
          })) || []
        }
        placeholder="Select Emirate"
        dropdownProps={{ filterable: true }}
        info={!watch("country") ? "Select country To Enable" : ""}
      />
      <FormInput {...generalFieldProps} label="Postal Code" name="postalCode" />
      <FormInput {...generalFieldProps} label="Address " name="address" />
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Barcode"
        name="barcode"
        rules={formValidationRules.barcode}
      />
      <FormHookDatePicker
        {...generalFieldProps}
        label="Start Date"
        name="startDate"
      />
      <FormHookDatePicker
        {...generalFieldProps}
        label="In Active Date"
        name="inactiveDate"
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Status"
        name="status"
        id="id"
        text="text"
        data={[
          { id: "Active", text: "Active" },
          { id: "Closed", text: "Closed" },
        ]}
        placeholder="Select Status"
        dropdownProps={{ filterable: true }}
        rules={formValidationRules.status}
      />

      <NumericInput {...generalFieldProps} label="Longitude" name="longitude" />
      <NumericInput {...generalFieldProps} label="Latitude" name="latitude" />
      <Heading
        style={{
          width: "100%",
          fontSize: "14px",
          borderTop: `1px solid var(--primary-light)`,
          padding: "10px 0px",
          margin: 0,
        }}
      >
        Operational Windows
      </Heading>

      <FormControl isRequired>
        <FormLabel>Start Date Time</FormLabel>
        <Controller
          control={generalFieldProps.control}
          name="startDateTime"
          render={({ field }) => {
            return (
              <DateTimePicker
                className={errors.startDateTime ? "error-field" : ""}
                value={field.value || null}
                onChange={(e) => {
                  field.onChange(e.value);
                  setValue("endDateTime", e.value);
                }}
              />
            );
          }}
        />

        {errors ? (
          errors.startDateTime ? (
            <p className="error-message">
              {errors.startDateTime.message || "Please Select Date!"}
            </p>
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
      </FormControl>
      <FormControl isRequired>
        <FormLabel>End Date Time</FormLabel>
        <Controller
          control={generalFieldProps.control}
          name="endDateTime"
          render={({ field }) => {
            return (
              <DateTimePicker
                className={errors.endDateTime ? "error-field" : ""}
                value={field.value || null}
                min={watch("startDateTime")}
                onChange={(e) => {
                  field.onChange(e.value);
                }}
              />
            );
          }}
        />

        {errors ? (
          errors.endDateTime ? (
            <p className="error-message">
              {errors.endDateTime.message || "Please Select Date!"}
            </p>
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
      </FormControl>

      <FormControl isRequired>
        <FormLabel>Cut Off Time</FormLabel>
        <Controller
          control={generalFieldProps.control}
          name="cutOffTime"
          render={({ field }) => {
            return (
              <TimePicker
                className={errors.cutOffTime ? "error-field" : ""}
                value={field.value || null}
                onChange={(e) => {
                  field.onChange(e.value);
                }}
              />
            );
          }}
        />

        {errors ? (
          errors.cutOffTime ? (
            <p className="error-message">
              {errors.cutOffTime.message || "Please Select Time!"}
            </p>
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
      </FormControl>
      <Grid data={operationalWindowFields}>
        <GridColumn
          title="Start Date Time"
          cell={({ dataItem }) => (
            <td>
              {dataItem.startDateTime ? (
                moment(dataItem.startDateTime).format(dateTimeFormat)
              ) : (
                <></>
              )}
            </td>
          )}
        />
        <GridColumn
          title="End Date Time"
          cell={({ dataItem }) => (
            <td>
              {dataItem.endDateTime ? (
                moment(dataItem.endDateTime).format(dateTimeFormat)
              ) : (
                <></>
              )}
            </td>
          )}
        />
        <GridColumn
          title="Cut Off Time"
          cell={({ dataItem }) => (
            <td>
              {dataItem.cutOffTime ? (
                moment(dataItem.cutOffTime).format(dateTimeFormat)
              ) : (
                <></>
              )}
            </td>
          )}
        />
        <GridColumn title="Edit" cell={editWindowCell} width={120} />
        <GridColumn title="Delete" cell={deleteWindowCell} width={120} />
      </Grid>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
        }}
      >
        {currentEditingWindow !== null ? (
          <Button
            type="button"
            onClick={() => {
              cancelWindowEditing();
            }}
          >
            Cancel
          </Button>
        ) : (
          <></>
        )}

        <Button onClick={addOperationalWindow}>
          {currentEditingWindow !== null ? "Update Window" : "Add Window"}
        </Button>
      </div>
      <Grid
        data={officeFields}
        detail={DetailComponent}
        expandField="expanded"
        onExpandChange={expandChange}
      >
        <GridColumn title="Name" field="officeName" />
        <GridColumn title="Type" field="officeType" />
        <GridColumn title="Barcode" field="barcode" />
        <GridColumn title="Status" field="status.text" />
        <GridColumn title="Address" field="address" />
        <GridColumn title="Edit" cell={editOfficeCell} width={120} />
        <GridColumn title="Delete" cell={deleteOfficeCell} width={120} />
      </Grid>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
          borderTop: `1px solid var(--primary-light)`,
          paddingTop: "16px",
        }}
      >
        {currentEditing !== null ? (
          <Button
            type="button"
            onClick={() => {
              cancelOfficeEditing();
            }}
          >
            Cancel
          </Button>
        ) : (
          <></>
        )}
        <Button type="submit">
          {currentEditing !== null ? "Update Office" : "Add Office"}
        </Button>
      </div>
    </form>
  );
}
